'use strict';
'use es6';
// this client needs to use the base no-auth
// the request to file manager will not succeed with additional query params

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadAttachmentClient = undefined;

var _noAuthApiClient = require('conversations-internal-clients/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uploadAttachmentClient = exports.uploadAttachmentClient = function uploadAttachmentClient(_ref) {
  var formData = _ref.formData,
      uploadUrl = _ref.uploadUrl,
      _ref$onProgress = _ref.onProgress,
      onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress;

  return _noAuthApiClient2.default.post(uploadUrl, {
    headers: {
      'content-type': false
    },
    data: formData,
    timeout: 0,
    withXhr: function withXhr(xhr) {
      xhr.upload.addEventListener('progress', onProgress, false);
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/clients/uploadAttachmentClient.js
// module id = 657
// module chunks = 2 3